import {
  DESKTOP_MIN_WIDTH,
  LG_DESKTOP_MIN_WIDTH,
  TABLET_MAX_WIDTH,
  TABLET_MIN_WIDTH
} from '../../constants/ResponsiveConstants';

import { getWindowInnerHeight } from '../WindowUtils';

export const mobile = `@media (max-width: ${TABLET_MIN_WIDTH - 1}px) `;

export const portraitMobile = `@media (orientation: portrait) and (max-width: ${
  TABLET_MIN_WIDTH - 1
}px) `;

export const tablet = `@media (min-width: ${TABLET_MIN_WIDTH}px) and (max-width: ${
  DESKTOP_MIN_WIDTH - 1
}px)`;

export const portraitTablet = `@media (min-width: ${TABLET_MIN_WIDTH}px) and (max-width: ${
  TABLET_MAX_WIDTH - 1
}px)`;

export const smDesktop = `@media (min-width: ${DESKTOP_MIN_WIDTH - 1}px)`;

export const mdDesktop = `@media (min-width: ${DESKTOP_MIN_WIDTH}px) and (max-width: ${
  LG_DESKTOP_MIN_WIDTH - 1
}px)`;

export const desktop = `@media (min-width: ${DESKTOP_MIN_WIDTH}px)`;

export const lgDesktop = `@media (min-width: ${LG_DESKTOP_MIN_WIDTH}px)`;

export const mobileOrTablet = `@media (max-width: ${TABLET_MAX_WIDTH - 1}px)`;

export const customDevice = (minWidth: number, maxWidth: number) =>
  `@media (min-width: ${minWidth}px) and (max-width: ${maxWidth}px)`;

export const minDeviceWidth = (minWidth: number) =>
  `@media (min-width: ${minWidth}px)`;

export const maxDeviceWidth = (maxWidth: number) =>
  `@media (max-width: ${maxWidth}px)`;

export const maxDeviceHeight = (maxHeight: number) =>
  `@media (max-height: ${maxHeight}px)`;

export const minDeviceWidthAndMinHeight = (
  minWidth: number,
  minHeight: number
) => `@media (min-width: ${minWidth}px) and (min-height:${minHeight}px)`;

export const windowInnerHeight = (): string => `${getWindowInnerHeight()}px`;

export const browserScreenHeight = (): string => windowInnerHeight();
